import { createContext, useMemo } from 'react'
import { UserRole, useUserRoles } from '@/hooks/use-user-roles'

export type UserContextType = {
  roles: UserRole[] | null
}

export const UserContext = createContext<UserContextType>({
  roles: [],
})

export type UserContextProviderProps = {
  children: React.ReactNode
}

export const UserContextProvider = ({ children }: UserContextProviderProps) => {
  const { roles } = useUserRoles()

  const providerValue = useMemo(
    () => (
      <UserContext.Provider
        value={{
          roles,
        }}
      >
        {children}
      </UserContext.Provider>
    ),
    [roles]
  )

  return providerValue
}
